var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28982 5.9997L6.82982 2.4597C7.01607 2.27234 7.12061 2.01889 7.12061 1.7547C7.12061 1.49052 7.01607 1.23707 6.82982 1.0497C6.73686 0.955976 6.62626 0.881582 6.5044 0.830813C6.38254 0.780044 6.25183 0.753906 6.11982 0.753906C5.98781 0.753906 5.8571 0.780044 5.73524 0.830813C5.61339 0.881582 5.50278 0.955976 5.40982 1.0497L1.16982 5.2897C1.07609 5.38267 1.0017 5.49327 0.950931 5.61513C0.900162 5.73699 0.874023 5.86769 0.874023 5.9997C0.874023 6.13172 0.900162 6.26242 0.950931 6.38428C1.0017 6.50614 1.07609 6.61674 1.16982 6.7097L5.40982 10.9997C5.50326 11.0924 5.61408 11.1657 5.73592 11.2155C5.85775 11.2652 5.98821 11.2905 6.11982 11.2897C6.25143 11.2905 6.38189 11.2652 6.50373 11.2155C6.62557 11.1657 6.73638 11.0924 6.82982 10.9997C7.01607 10.8123 7.12061 10.5589 7.12061 10.2947C7.12061 10.0305 7.01607 9.77707 6.82982 9.5897L3.28982 5.9997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.21aa2c381014376b46c64ed1d810c360.svg";
export { ForwardRef as ReactComponent };